export default __webpack_public_path__ + "static/media/dark-hair-young-woman.8730678d.jpg";